import { INTERNAL_ERROR_CATEGORY } from './errors';

export default function ErrorLogger(transactionId) {
  const NR_THIRD_PARTY_ERROR_STACK_TRACE_REGEXPS = [
    /chrome-extension:/,
    /facebook\.net/,
  ];
  const TXID_REGEX = /TXID((\+[a-fA-F0-9]{20})+)/;
  const TIMESTAMP_JS_REGEX = /\.js\?t[0-9]+([\s])/;

  window.newrelic.setCustomAttribute('TXID', transactionId);

  this.maskErrorMessage = (message) => {
    let result = message.replace(TXID_REGEX, `TXID+${'#'.repeat(20)}`);
    result = result.replace(TIMESTAMP_JS_REGEX, `.js?t${'#'.repeat(13)}$1`);
    return result;
  };

  this.getTxidForError = (e) => {
    let matches = e.message.match(TXID_REGEX);
    if (matches && matches.length > 1) {
      return transactionId + matches[1];
    }

    return transactionId;
  };

  this.scanForRegexMatch = (message, regexList) =>
    regexList.some((regexp) => regexp.test(message));

  this.categorizeError = (e) => {
    if (Reflect.has(e, 'category') && e.category) {
      return e.category;
    }

    if (
      this.scanForRegexMatch(e.stack, NR_THIRD_PARTY_ERROR_STACK_TRACE_REGEXPS)
    ) {
      return 'third-party';
    }

    return INTERNAL_ERROR_CATEGORY;
  };

  this.logError = (e) => {
    window.newrelic.noticeError(e);
  };

  this.logBrowserError = (e) => {
    window.newrelic.setCustomAttribute('TXID', this.getTxidForError(e));
    window.newrelic.setCustomAttribute('error_type', this.categorizeError(e));
    e.message = this.maskErrorMessage(e.message);

    return false;
  };

  window.newrelic.setErrorHandler(this.logBrowserError);
}
